<template>
  <div class="merge-job-host">
    <CRow class="content-fade-in" ref="container">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="12" md="12" xl="12">
                  <BaseInput
                    :options="titleInput.options"
                    :data="titleInput.data"
                    :listener="titleInput.listener"
                  />
                </CCol>
                <CCol sm="12" md="12" xl="12">
                  <div class="form-input-wrapper">
                    <div class="form-group">
                      <label class="form-label" for="uploadFile">Chọn file <span class="required">*</span> (.mp3 , .wav, .aac, .m4a, .flac, .ogg)</label>
                      <div class="custom-file"
                           :class="selectedFiles.data.validator.isValid == false ? 'input-valid-error' : ''">
                        <input type="file" class="custom-file-input" id="uploadFile" ref="file" accept=".mp3 , .wav, .aac, .m4a, .flac, .ogg"
                               multiple @change="selectFile($event)">
                        <label class="custom-file-label" for="uploadFile">Chọn tệp</label>
                      </div>
                      <span class="valid-error">{{ selectedFiles.data.validator.errorMessage }}</span>
                    </div>
                  </div>
                </CCol>
                <CCol xs="12" sm="12" md="12" xl="12" class="mt-4">
                  <!--                                    <CDataTable-->
                  <!--                                      :items="selectedFiles.data.model"-->
                  <!--                                      :fields="chooseFileTable.options.fields"-->
                  <!--                                      :sorterValue="{ column: null, asc: 'true' }"-->
                  <!--                                    >-->
                  <!--                                      <template #name="{item}">-->
                  <!--                                        <td>{{ item.fileName }}</td>-->
                  <!--                                      </template>-->
                  <!--                                      <template #url="{item}">-->
                  <!--                                        <td>-->
                  <!--                                          <audio controls aria-label="Tệp chuyển đổi" class="audio-css" :ref="item.urlBlob"-->
                  <!--                                                 style="width: 80%; min-width: 300px;">-->
                  <!--                                            <source :src="item.urlBlob" type="audio/mpeg">-->
                  <!--                                            <source :src="item.urlBlob" type="audio/wav">-->
                  <!--                                          </audio>-->
                  <!--                                        </td>-->
                  <!--                                      </template>-->
                  <!--                                      <template #size="{item}">-->
                  <!--                                        <td>-->
                  <!--                                          {{ (item.size / (1024 * 1024)).toFixed(2) }}-->
                  <!--                                        </td>-->
                  <!--                                      </template>-->
                  <!--                                      <template #action="{item, index}">-->
                  <!--                                        <td class="action-btn-group">-->
                  <!--                                          <div class="action-btn-wrapper">-->
                  <!--                                            <CButton color="info"-->
                  <!--                                                     variant="outline"-->
                  <!--                                                     v-c-tooltip.hover="'Lên vị trí'"-->
                  <!--                                                     square-->
                  <!--                                                     size="sm"-->
                  <!--                                                     :disabled="index === 0"-->
                  <!--                                                     @click="changeIndexFile(index, 'up')">-->
                  <!--                                              <CIcon name="cil-arrow-top"/>-->
                  <!--                                            </CButton>-->
                  <!--                                            <CButton-->
                  <!--                                              color="info"-->
                  <!--                                              variant="outline"-->
                  <!--                                              class="ml-1"-->
                  <!--                                              square-->
                  <!--                                              size="sm"-->
                  <!--                                              :disabled="index === selectedFiles.data.model.length - 1"-->
                  <!--                                              @click="changeIndexFile(index, 'down')"-->
                  <!--                                              v-c-tooltip.hover="'Xuống vị trí'">-->
                  <!--                                              <CIcon name="cil-arrow-bottom"/>-->
                  <!--                                            </CButton>-->
                  <!--                                            <CButton-->
                  <!--                                              color="danger"-->
                  <!--                                              variant="outline"-->
                  <!--                                              class="ml-1"-->
                  <!--                                              square-->
                  <!--                                              size="sm"-->
                  <!--                                              @click="deleteFile(index)"-->
                  <!--                                              v-c-tooltip.hover="'Xóa'">-->
                  <!--                                              <CIcon name="cil-trash"/>-->
                  <!--                                            </CButton>-->
                  <!--                                          </div>-->
                  <!--                                        </td>-->
                  <!--                                      </template>-->
                  <!--                                      <template slot="no-items-view">-->
                  <!--                                        <span style="color:#969696;">Danh sách trống!</span>-->
                  <!--                                      </template>-->
                  <!--                                      <template slot="loading">-->
                  <!--                                        <BaseLoading :loading="loading"/>-->
                  <!--                                      </template>-->
                  <!--                                    </CDataTable>-->

                  <div class="position-relative table-responsive">
                    <table class="table">
                      <thead>
                      <tr>
                        <th style="vertical-align: middle; overflow: hidden; width: 40%;">
                          <div>Tên</div>
                        </th>
                        <th style="vertical-align: middle; overflow: hidden; width: 30%;">
                          <div>File</div>
                        </th>
                        <th style="vertical-align: middle; overflow: hidden; width: 10%;">
                          <div>Dung lượng (Mb)</div>
                        </th>
                        <th style="vertical-align: middle; overflow: hidden; width: 10%;">
                          <div>Thao tác</div>
                        </th>
                      </tr>
                      </thead>
                      <tbody class="position-relative">
                      <draggable :list="selectedFiles.data.model" ghost-class="ghost" style="display: contents"
                                 group="people"
                                 :move="checkMoveLayer"
                                 @start="startDraggable"
                                 @end="endDraggable">
                        <template v-for="(each, index) in selectedFiles.data.model">
                          <tr>
                            <td>{{ each.fileName }}</td>
                            <td>
                              <audio controls="controls" aria-label="Tệp chuyển đổi" class="audio-css"
                                     style="width: 80%;min-width: 300px;" ref="audio">
                                <source
                                  :src="each.urlBlob"
                                  type="audio/mpeg">
                                <source
                                  :src="each.urlBlob"
                                  type="audio/wav">
                              </audio>
                            </td>
                            <td>{{ (each.size / (1024 * 1024)).toFixed(2) }}</td>
                            <td>
                              <CButton
                                color="danger"
                                variant="outline"
                                class="ml-1"
                                square
                                size="sm"
                                @click="deleteFile(index)"
                                v-c-tooltip.hover="'Xóa'">
                                <i class="fa fa-trash" style="font-size: 15px!important;"></i>
                              </CButton>
                            </td>
                          </tr>
                        </template>
                      </draggable>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="selectedFileCount > 0" class="merge-file-summary">
                    <div class="merge-file-summary-item">
                      <span class="merge-file-summary-label">Tổng tệp đã chọn</span>
                      <strong class="merge-file-summary-value">{{ selectedFileCount }} tệp</strong>
                    </div>
                    <div class="merge-file-summary-item">
                      <span class="merge-file-summary-label">Tổng thời lượng</span>
                      <strong class="merge-file-summary-value">{{ selectedFileTotalDuration }}</strong>
                    </div>
                    <div class="merge-file-summary-item">
                      <span class="merge-file-summary-label">Tổng dung lượng</span>
                      <strong class="merge-file-summary-value">{{ selectedFileTotalMb }} MB</strong>
                    </div>
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol style="display: inline-flex;align-items: center" v-show="fileMergeResult" class="mt-4">
                  <audio controls aria-label="Tệp chuyển đổi" ref="resultFile" class="audio-css">
                    <source :src="fileMergeResult.path" type="audio/mpeg">
                    <source :src="fileMergeResult.path" type="audio/wav">
                  </audio>
                  <CButton color="success" class="btn-action-primary ml-2"
                           @click="downloadByUrl()"><i class="fa fa-download"></i>&nbsp;Tải xuống
                  </CButton>
                  <CButton color="primary" class="btn-action-primary ml-2" @click="clickAddFile()"><i
                    class="fa fa-file"></i>&nbsp;Biên tập
                  </CButton>
                </CCol>
              </CRow>
              <br/>
              <CRow>
                <CCol sm="6" md="6">
                  <CButton
                    color="primary"
                    class="btn-action-primary mr-2"
                    @click="submitData"
                  >
                    <i class="fa fa-code-fork"></i>&nbsp;Xử lý ghép file
                  </CButton>
                  <CButton
                    color="secondary"
                    class="btn-action-primary mr-2"
                    @click="resetData()"
                  ><i class="fa fa-eraser"></i>&nbsp;Làm mới
                  </CButton>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
        <BaseAudioAddFile v-if="isShowFileAdd" :file="fileAddContent" :duration="durationFileAdd" :url="url"
                          @loading="loadingAdd($event)" :type="fileType"></BaseAudioAddFile>
      </CCol>
      <BaseLoading :loading="loading.value && !mergeJobInProgress"></BaseLoading>
    </CRow>

    <transition name="merge-job-fade">
      <div
        v-if="mergeJobInProgress"
        class="merge-job-overlay"
        role="status"
        aria-live="polite"
        aria-labelledby="merge-job-title"
      >
        <div class="merge-job-panel">
          <div class="merge-job-panel-line" aria-hidden="true"></div>
          <div class="merge-job-head">
            <div class="merge-job-icon-ring">
              <i class="fa fa-code-fork merge-job-fork" aria-hidden="true"></i>
            </div>
            <h4 id="merge-job-title" class="merge-job-title">Đang ghép tệp tin âm thanh</h4>
            <div class="merge-job-percent-chip">{{ mergeProgressDisplay }}%</div>
          </div>
          <div class="merge-job-status-line">{{ mergeProgressDisplay < 100 ? 'Đang xử lý, vui lòng chờ trong giây lát...' : 'Đã hoàn tất xử lý tệp âm thanh.' }}</div>

          <div class="merge-job-progress-block">
            <div
              class="merge-job-track"
              role="progressbar"
              aria-valuemin="0"
              aria-valuemax="100"
              :aria-valuenow="mergeProgressDisplay"
              aria-label="Tiến độ ghép tệp tin"
            >
              <div class="merge-job-fill" :style="{ width: mergeProgressDisplay + '%' }">
                <span class="merge-job-fill-shine" aria-hidden="true"></span>
              </div>
            </div>
            <div class="merge-job-progress-meta">
              <span class="meta-start">0%</span>
              <span class="meta-center">Tiến độ ghép tệp tin</span>
              <span class="meta-end">{{ mergeProgressDisplay }}%</span>
            </div>
          </div>

          <div class="merge-job-warning" role="status" aria-live="polite">
            <div class="merge-job-warning-icon" aria-hidden="true">
              <i class="fa fa-exclamation"></i>
            </div>
            <div class="merge-job-warning-content">
              <div class="merge-job-warning-title">Lưu ý quan trọng</div>
              <div class="merge-job-warning-text">Không đóng hoặc tắt trình duyệt trong quá trình ghép tệp tin.</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";
import {FILE_MERGE_MAX_SIZE, FileType} from "@/constant";
import BaseAudioAddFile from "@/views/base/BaseAddFile";
import draggable from 'vuedraggable';

const MERGE_FILE_MAX_COUNT = 15;

export default {
  name: "MergeFile",
  components: {BaseAudioAddFile, BaseSelect, BaseInput, BaseLoading, draggable},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      mergeFileMaxCount: MERGE_FILE_MAX_COUNT,
      fileType: FileType.GHEP_TEP,
      loading: {value: false},
      fileAddContent: {
        fileName: '',
        content: ''
      },
      url: '',
      durationFileAdd: '',
      isShowFileAdd: false,
      fileMergeResult: '',
      mergeResultMeta: null,
      /** true khi đang chạy luồng ghép (overlay thay BaseLoading) */
      mergeJobInProgress: false,
      /** null = không ghép; 0–100 khi đang poll job ghép */
      mergeProgressPercent: null,
      titleInput: {
        options: {
          label: "Tên tệp tin <span class='required'>*</span>",
          placeholder: "Tên tệp tin",
          type: "text"
        },
        data: {
          name: "title",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.titleInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tên tệp tin không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      selectedFiles: {
        data: {
          name: "files",
          model: [],
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.selectedFiles.data.model;
              if (value.length == 0) {
                this.isValid = false;
                this.errorMessage = "File không được để trống";
              } else if (value.length == 1) {
                this.isValid = false;
                this.errorMessage = "Tối thiểu phải 2 file";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        },
      },
      chooseFileTable: {
        options: {
          fields: [
            {key: "name", label: "Tên", _style: 'width: 40%;'},
            {key: "url", label: "File", _style: 'width: 30%;'},
            {key: "size", label: "Dung lượng (Mb)", _style: 'width: 10%;'},
            {key: "action", label: "Thao tác", _style: 'width: 10%;'}
          ],
          slots: ["index", "name", "size", "url", "action"],
        },
      },
      fileRequest: []
    };
  },
  methods: {
    handleBeforeUnload(event) {
      if (!this.mergeJobInProgress) {
        return undefined;
      }
      event.preventDefault();
      event.returnValue = '';
      return '';
    },
    async selectFile(event) {
      console.log(event.target.files)
      let that = this;
      if (event.target.files.length > 0) {
        this.loading.value = true;
        if (this.selectedFiles.data.model.length < MERGE_FILE_MAX_COUNT) {
          Promise.all(
            (function* () {
              let _that = that;
              for (let file of event.target.files) {
                yield new Promise(resolve => {
                  let reader = new FileReader();
                  reader.onload = async () => {
                    const durationSeconds = await _that.readAudioDuration(file);
                    let data = {
                      fileName: file.name,
                      type: file.type,
                      size: file.size,
                      urlBlob: _that.convertBlob(reader.result),
                      durationSeconds: durationSeconds
                    }
                    resolve(data)
                  };
                  reader.readAsDataURL(file);
                })
                that.fileRequest.push(file)
              }
            })())
            .then(texts => {
              texts.map(each => {
                if (this.validateFile(each)) {
                  this.selectedFiles.data.model.push(each)
                }
              })
              setTimeout(() => {
                event.target.value = null;
                that.loading.value = false
              }, 300)
            }).catch(error => {
              that.loading.value = false;
              // console.log(error);
            });
        } else {
          this.showWarningMsg({ message: `Xử lý tối đa ${MERGE_FILE_MAX_COUNT} file` })
          this.loading.value = false;
        }
      }
    },
    validateFile(file) {
      if (this.selectedFiles.data.model.length >= MERGE_FILE_MAX_COUNT) {
        return false;
      } else {
        if (file && file.type !== 'audio/wav' && file.type !== 'audio/mpeg' && file.type !== "audio/vnd.dlna.adts" && file.type !== "audio/x-m4a"
        && file.type !== "audio/ogg" && file.type !== "audio/flac" 
        ) {
          return false;
        }
        return true;
      }
    },
    validateSizeFile() {
      if (this.selectedFiles.data.model.length > 0) {
        let totalSize = this.selectedFiles.data.model.map(each => each.size).reduce((a, b) => a + b);
        if (totalSize > FILE_MERGE_MAX_SIZE) {
          this.selectedFiles.data.validator.isValid = false;
          this.selectedFiles.data.validator.errorMessage = "Tổng tệp tin không quá 150Mb";
          return false;
        }
        return true;
      }
    },
    convertDataURIToBinary(dataURI) {
      let BASE64_MARKER = ';base64,';
      let base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
      let base64 = dataURI.substring(base64Index);
      let raw = window.atob(base64);
      let rawLength = raw.length;
      let array = new Uint8Array(new ArrayBuffer(rawLength));
      for (let i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
      }
      return array;
    },
    convertBlob(data) {
      let binary = this.convertDataURIToBinary(data);
      let blob = new Blob([binary], {type: 'audio/wav'});
      return URL.createObjectURL(blob);
    },
    readAudioDuration(file) {
      return new Promise((resolve) => {
        try {
          const objectUrl = URL.createObjectURL(file);
          const audio = document.createElement('audio');
          audio.preload = 'metadata';
          audio.onloadedmetadata = function () {
            const seconds = Number.isFinite(audio.duration) ? Math.max(0, audio.duration) : 0;
            URL.revokeObjectURL(objectUrl);
            resolve(seconds);
          };
          audio.onerror = function () {
            URL.revokeObjectURL(objectUrl);
            resolve(0);
          };
          audio.src = objectUrl;
        } catch (e) {
          resolve(0);
        }
      });
    },
    formatDuration(totalSeconds) {
      const safeSeconds = Math.max(0, Math.floor(Number(totalSeconds) || 0));
      const hour = Math.floor(safeSeconds / 3600).toString().padStart(2, '0');
      const minute = Math.floor((safeSeconds % 3600) / 60).toString().padStart(2, '0');
      const second = (safeSeconds % 60).toString().padStart(2, '0');
      return `${hour}:${minute}:${second}`;
    },
    changeIndexFile(index, type) {
      this.loading.value = true;
      if (type == 'up') {
        this.arrayMove(index, index - 1);
      } else if (type == 'down') {
        this.arrayMove(index, index + 1);
      }
    },
    async deleteFile(index) {
      let that = this;
      this.loading.value = true;
      this.selectedFiles.data.model.splice(index, 1);
      this.fileRequest.splice(index, 1);
      setTimeout(() => {
        this.reloadAudio(that.selectedFiles.data.model).then(result => {
          that.loading.value = false;
        });
      }, 100)
    },
    async reloadAudio(files) {
      let that = this;
      const promise = await new Promise((resolve) => {
        if (that.$refs.audio && that.$refs.audio.length > 0) {
          that.$refs.audio.map(each => each.load());
          // files.map(each => that.$refs[each.urlBlob].load());
          resolve(files)
        }
      })
      return promise;
    },
    async arrayMove(old_index, new_index) {
      let data = [this.selectedFiles.data.model, this.fileRequest];
      Promise.all(
        (function* () {
          for (let each of data) {
            yield new Promise(resolve => {
              if (new_index >= each.length) {
                let k = new_index - each.length + 1;
                while (k--) {
                  each.push(undefined);
                }
              }
              each.splice(new_index, 0, each.splice(old_index, 1)[0]);
              resolve(each)
            })
          }
        })())
        .then(() => {
          this.reloadAudio(this.selectedFiles.data.model)
          setTimeout(() => {
            this.loading.value = false;
          }, 100)
        }).catch(error => {
        // console.log(error);
      })
    },
    async downloadByUrl() {
      if (!this.fileMergeResult || !this.fileMergeResult.path) {
        this.showWarningMsg({message: "Không tìm thấy tệp để tải xuống"});
        return;
      }
      let downloadHref = this.fileMergeResult.path;
      let tempObjectUrl = null;
      try {
        if (this.mergeResultMeta && this.mergeResultMeta.keyStorage) {
          const blob = await this.$helper.fetchBlobFileByUrl(
            process.env.API_ENDPOINT + "/file-management/download-key/" + this.mergeResultMeta.keyStorage
          );
          tempObjectUrl = URL.createObjectURL(blob);
          downloadHref = tempObjectUrl;
        } else if (typeof downloadHref === "string" && !downloadHref.startsWith("blob:")) {
          const blob = await this.$helper.fetchToBlob(downloadHref);
          tempObjectUrl = URL.createObjectURL(blob);
          downloadHref = tempObjectUrl;
        }

        const a = document.createElement("a");
        a.href = downloadHref;
        a.download = this.fileMergeResult.fileName || (this.titleInput.data.model + ".mp3");
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (e) {
        this.$helper.handleError(this.$router, e);
        this.showErrorMsg({message: "Tải xuống tệp thất bại. Vui lòng thử lại."});
      } finally {
        if (tempObjectUrl) {
          URL.revokeObjectURL(tempObjectUrl);
        }
      }
    },
    resetData() {
      this.titleInput.data.model = '';
      this.selectedFiles.data.model = [];
      this.fileRequest = [];
      this.fileMergeResult = '';
      this.mergeResultMeta = null;
      this.mergeJobInProgress = false;
      this.mergeProgressPercent = null;
      this.isShowFileAdd = false;
      this.fileAddContent.fileName = '';
      this.fileAddContent.content = '';
      this.$refs.file.value = null;
    },
    async applyMergeSuccessFromData(d) {
      let that = this;
      that.url = d.path;
      let blob = null;
      if (d.keyStorage && d.keyStorage != null && d.keyStorage != '') {
        blob = await that.$helper.fetchBlobFileByUrl(process.env.API_ENDPOINT + "/file-management/download-key/" + d.keyStorage)
      } else {
        blob = await that.$helper.fetchToBlob(d.path)
      }
      let url = URL.createObjectURL(blob)
      that.fileMergeResult = {
        path: url,
        fileName: d.fileName
      };
      that.mergeResultMeta = d;
      that.$refs.resultFile.load();
      that.showSuccessMsg({message: "Ghép tệp tin thành công"});
      let base64 = await that.$helper.blobToBase64(blob);
      that.fileAddContent.content = base64;
      that.fileAddContent.fileName = that.titleInput.data.model + ".mp3";
      var audio = document.createElement('audio');
      audio.src = url;
      audio.addEventListener('loadedmetadata', function () {
        var duration = new Date(audio.duration * 1000).toISOString().substr(11, 8);
        that.durationFileAdd = duration;
      }, false);
    },
    pollMergeStatus(jobId, intervalMs) {
      let that = this;
      that.mergeProgressPercent = 0;
      const maxMs = 60 * 60 * 1000;
      let elapsed = 0;
      const statusUrl = process.env.API_ENDPOINT + "/file-management/merge-file/status/" + jobId;
      const headers = {
        Authorization: 'Bearer ' + that.$helper.getAccessToken(),
        'Content-Type': 'application/json;charset=utf-8'
      };

      const poll = async () => {
        try {
          const res = await axios.post(statusUrl, {}, {headers});
          const payload = res.data;
          if (!that.$helper.validResponse(that.$router, payload)) {
            that.loading.value = false;
            that.mergeJobInProgress = false;
            that.mergeProgressPercent = null;
            return;
          }
          const d = payload.data;
          const st = d.status;
          if (typeof d.progressPercent === 'number' && !Number.isNaN(d.progressPercent)) {
            that.mergeProgressPercent = Math.max(0, Math.min(100, Math.round(d.progressPercent)));
          }
          if (st === 'PENDING' || st === 'PROCESSING') {
            elapsed += intervalMs;
            if (elapsed > maxMs) {
              that.loading.value = false;
              that.mergeJobInProgress = false;
              that.mergeProgressPercent = null;
              that.showErrorMsg({message: 'Chờ ghép tệp tin quá lâu. Vui lòng thử lại sau.'});
              return;
            }
            setTimeout(poll, intervalMs);
            return;
          }
          if (st === 'SUCCESS') {
            that.mergeProgressPercent = 100;
            try {
              await that.applyMergeSuccessFromData(d);
            } finally {
              that.loading.value = false;
              that.mergeJobInProgress = false;
              that.mergeProgressPercent = null;
            }
            return;
          }
          const errMsg = d.error || that.$helper.getStringError(d);
          that.showErrorMsg({message: errMsg});
          that.loading.value = false;
          that.mergeJobInProgress = false;
          that.mergeProgressPercent = null;
        } catch (e) {
          that.$helper.handleError(that.$router, e);
          that.loading.value = false;
          that.mergeJobInProgress = false;
          that.mergeProgressPercent = null;
        }
      };
      poll();
    },
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= this.titleInput.data.validator.valid();
      isValid &= this.selectedFiles.data.validator.valid();
      isValid &= this.validateSizeFile();
      if (!isValid) {
        return;
      }
      this.mergeJobInProgress = true;
      this.mergeProgressPercent = 0;
      this.loading.value = true;

      let formData = new FormData();
      formData.append("title", this.titleInput.data.model);
      for (let each of this.fileRequest) {
        formData.append("files", each);
      }
      that.$helper.loadDataSource({
        url: "/file-management/merge-file",
        dataSubmit: function () {
          return formData;
        },
        isMultiPartFormData: true,
        successCallback: async function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
            that.mergeJobInProgress = false;
            that.mergeProgressPercent = null;
          } else {
            const d = response.data.data;
            if (d.async && d.jobId) {
              const interval = d.pollIntervalMs != null ? d.pollIntervalMs : 2000;
              if (typeof d.progressPercent === 'number') {
                that.mergeProgressPercent = Math.max(0, Math.min(100, Math.round(d.progressPercent)));
              } else {
                that.mergeProgressPercent = 0;
              }
              that.pollMergeStatus(d.jobId, interval);
              return;
            }
            try {
              await that.applyMergeSuccessFromData(d);
            } finally {
              that.mergeJobInProgress = false;
              that.mergeProgressPercent = null;
            }
          }
          that.loading.value = false
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.mergeJobInProgress = false;
          that.mergeProgressPercent = null;
          that.loading.value = false
        }
      });
    },
    clickAddFile() {
      let that = this;
      this.isShowFileAdd = true;
      setTimeout(() => {
        let container = that.$refs.container;
        window.scrollTo({left: 100, top: container.scrollHeight, behavior: "smooth"});
      }, 200);
    },
    loadingAdd(value) {
      if (value) {
        this.loading.value = true;
      } else {
        this.loading.value = false;
      }
    },
    checkMoveLayer(e) {
    },
    startDraggable(event) {
    },
    endDraggable(event) {
      this.array_move(this.fileRequest, event.oldIndex, event.newIndex)
    },
    array_move(arr, old_index, new_index) {
      if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      return arr;
    }

  },
  computed: {
    selectedFileCount() {
      return this.selectedFiles && this.selectedFiles.data && this.selectedFiles.data.model
        ? this.selectedFiles.data.model.length
        : 0;
    },
    selectedFileTotalMb() {
      if (!this.selectedFiles || !this.selectedFiles.data || !this.selectedFiles.data.model) {
        return '0.00';
      }
      const totalSize = this.selectedFiles.data.model
        .map(file => Number(file.size || 0))
        .reduce((sum, size) => sum + size, 0);
      return (totalSize / (1024 * 1024)).toFixed(2);
    },
    selectedFileTotalDuration() {
      if (!this.selectedFiles || !this.selectedFiles.data || !this.selectedFiles.data.model) {
        return '00:00:00';
      }
      const totalSeconds = this.selectedFiles.data.model
        .map(file => Number(file.durationSeconds || 0))
        .reduce((sum, duration) => sum + duration, 0);
      return this.formatDuration(totalSeconds);
    },
    mergeProgressDisplay() {
      const p = this.mergeProgressPercent;
      if (p == null || Number.isNaN(Number(p))) return 0;
      return Math.max(0, Math.min(100, Math.round(Number(p))));
    }
  },
  created() {
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  watch: {
    'selectedFiles.data.model': function () {
      let that = this;
      this.reloadAudio(that.selectedFiles.data.model).then(result => {
        that.loading.value = false;
      });
    }
  }
};
</script>

<style scoped>
.merge-job-host {
  position: relative;
}

.merge-file-summary {
  margin-top: 0.75rem;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.65rem;
}

.merge-file-summary-item {
  padding: 0.55rem 0.7rem;
  border-radius: 8px;
  background: #f8fbff;
  border: 1px solid #dbe7f6;
}

.merge-file-summary-label {
  display: block;
  color: #6b7280;
  font-size: 0.76rem;
  margin-bottom: 0.1rem;
}

.merge-file-summary-value {
  color: #1f2937;
  font-size: 0.93rem;
  font-weight: 700;
}

.merge-job-overlay {
  position: fixed;
  inset: 0;
  z-index: 20000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: rgba(15, 23, 42, 0.28);
  backdrop-filter: blur(3px);
}

.merge-job-panel {
  position: relative;
  width: 100%;
  max-width: 620px;
  padding: 1.35rem 1.4rem 1.35rem;
  border-radius: 14px;
  background: linear-gradient(180deg, #0f172a 0%, #111827 100%);
  box-shadow:
    0 16px 35px -18px rgba(2, 6, 23, 0.75),
    0 0 0 1px rgba(51, 65, 85, 0.95);
  color: #e2e8f0;
  overflow: hidden;
}

.merge-job-panel-line {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #22d3ee 0%, #3b82f6 50%, #6366f1 100%);
}

.merge-job-head {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  margin-bottom: 0.75rem;
}

.merge-job-icon-ring {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: rgba(30, 41, 59, 0.9);
  border: 1px solid rgba(56, 189, 248, 0.4);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12);
  flex-shrink: 0;
}

.merge-job-fork {
  font-size: 1.1rem;
  color: #67e8f9;
}

.merge-job-title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #f8fafc;
  flex: 1;
}

.merge-job-percent-chip {
  flex-shrink: 0;
  padding: 0.35rem 0.8rem;
  border-radius: 999px;
  background: rgba(14, 165, 233, 0.16);
  border: 1px solid rgba(56, 189, 248, 0.45);
  color: #bae6fd;
  font-size: 1rem;
  font-weight: 700;
  min-width: 78px;
  text-align: center;
}

.merge-job-status-line {
  margin-bottom: 0.78rem;
  color: #93c5fd;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.45;
}

.merge-job-progress-block {
  margin-bottom: 0.9rem;
}

.merge-job-track {
  height: 16px;
  border-radius: 999px;
  background: rgba(30, 41, 59, 0.96);
  box-shadow: inset 0 1px 3px rgba(2, 6, 23, 0.8);
  overflow: hidden;
  border: 1px solid rgba(71, 85, 105, 0.85);
}

.merge-job-fill {
  height: 100%;
  min-width: 2px;
  border-radius: 999px;
  background: linear-gradient(90deg, #06b6d4 0%, #0ea5e9 45%, #3b82f6 100%);
  box-shadow: 0 0 14px rgba(56, 189, 248, 0.38);
  transition: width 0.35s ease;
  position: relative;
  overflow: hidden;
}

.merge-job-fill-shine {
  position: absolute;
  top: -20%;
  left: -30%;
  width: 24%;
  height: 140%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.52) 50%, rgba(255, 255, 255, 0) 100%);
  transform: skewX(-22deg);
  animation: merge-job-shine 1.25s linear infinite;
}

.merge-job-progress-meta {
  margin-top: 0.58rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #64748b;
  font-size: 0.95rem;
}

.merge-job-progress-meta .meta-center {
  color: #94a3b8;
  font-weight: 700;
}

.merge-job-progress-meta .meta-start,
.merge-job-progress-meta .meta-end {
  min-width: 3.2rem;
  text-align: center;
}

.merge-job-progress-meta .meta-end {
  color: #7dd3fc;
  font-weight: 700;
}

@keyframes merge-job-shine {
  from {
    transform: translateX(-120%) skewX(-22deg);
  }
  to {
    transform: translateX(430%) skewX(-22deg);
  }
}

.merge-job-warning {
  display: flex;
  align-items: flex-start;
  gap: 0.82rem;
  padding: 0.85rem 0.95rem;
  border-radius: 12px;
  border: 1px solid rgba(251, 191, 36, 0.42);
  background: linear-gradient(90deg, rgba(120, 53, 15, 0.3) 0%, rgba(146, 64, 14, 0.24) 100%);
  color: #fde68a;
  line-height: 1.38;
}

.merge-job-warning-icon {
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(251, 191, 36, 0.2);
  border: 1px solid rgba(251, 191, 36, 0.4);
  margin-top: 0.02rem;
}

.merge-job-warning-icon i {
  font-size: 0.95rem;
  color: #facc15;
}

.merge-job-warning-content {
  min-width: 0;
}

.merge-job-warning-title {
  font-size: 1rem;
  font-weight: 700;
  color: #fef3c7;
  margin-bottom: 0.12rem;
}

.merge-job-warning-text {
  font-size: 0.92rem;
  font-weight: 600;
  color: #fde68a;
}

.merge-job-fade-enter-active,
.merge-job-fade-leave-active {
  transition: opacity 0.25s ease;
}

.merge-job-fade-enter,
.merge-job-fade-leave-to {
  opacity: 0;
}
</style>
